export default __webpack_public_path__ + "static/ai matching@3x-eeec3393abcc794292a4971fe521ac3e.png";